<script setup lang="ts">
import {onBeforeMount} from "vue";

definePageMeta({
  middleware: ['i18n-links'],
});
</script>

<template>
  <div class="landing-proxy">
    <NuxtPage />
  </div>
</template>

<style lang="scss" scoped>
.landing-proxy {
  font-family: AlsHauss, sans-serif;
  background: #fff;
}
</style>
